import type { IScreenSizes } from '@ui-screen/config/types'

export const SCREEN_SIZES: IScreenSizes = {
  xs: 500,
  s: 800,
  m: 1024,
  l: 1440,
  xl: 10000
}
